import React from 'react'
import { styled, Grid as GridBase } from '@mui/material'
import { CircleWarningIcon as CircleWarningIconBaseIcon, Button as BaseButton } from '@chilecompra/react-kit'

export const RootContainer = styled(props => <GridBase {...props} container />)`
  &.MuiGrid-container {
    padding: 37px 85px;
    ${props => props.theme.breakpoints.down('md')} {
      padding: 37px 28px;
    }
  }
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
  }
`

export const GridItem = styled(props => <GridBase {...props} item />)`
  &.MuiGrid-item {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
  }
`

export const Button = styled(props => <BaseButton {...props} />)`
  &.MuiButtonBase-root {
    min-width: 180px;
  }
  ${props => props.theme.breakpoints.down('md')} {
    &.MuiButtonBase-root {
      min-width: 300px;
    }
  }
`

export const CircleWarningIcon = styled(props => <CircleWarningIconBaseIcon {...props} item />)`
  font-size: 60px;
`

export const TextContainer = styled('div')`
  text-transform: uppercase;
`

export const ExclamationIcon = styled('img')`
  width: 64px;
  height: 64px;
`
